import { render, staticRenderFns } from "./CertPrequalRules.vue?vue&type=template&id=3c35a509"
import script from "./CertPrequalRules.vue?vue&type=script&lang=js"
export * from "./CertPrequalRules.vue?vue&type=script&lang=js"
import style0 from "./CertPrequalRules.vue?vue&type=style&index=0&id=3c35a509&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports